import { useContext } from 'react';
import PermissionContext from '../../store/PermissionContext';

const CheckPermission = ({ permission, children }) => {
      const permissionCtx = useContext(PermissionContext);
      const userPermissions = permissionCtx.userPermissions;

      return (
            userPermissions &&
            Array.isArray(userPermissions) &&
            userPermissions.includes(permission) &&
            children
      );
};

export default CheckPermission;
